import { IAdminGlobalMessage } from '@interfaces/adminGlobalMessages';

import { apiUrls } from './urls';
import { deletes, get, post } from './utils';

export const getAdminGlobalMessage = () => get<IAdminGlobalMessage>(apiUrls.globalMessage.get);

export const adminSetGlobalMessage = (payload: IAdminGlobalMessage) =>
  post(apiUrls.globalMessage.upsert, payload);

export const adminDeleteGlobalMessage = (id: number) =>
  deletes(apiUrls.globalMessage.delete, { id });
